/**
 * 底部菜单Tab
 */
import { FooterModel, useInitFooter } from "@/controller/global/InitFooter";
import React, { memo, useState } from "react";
import "./index.less";
import DFImage from "../DFImage";
export interface FooterPartProps {
  unionConfig: any;
}
const FooterPart = (props: FooterPartProps) => {
  const [footerConfig, setFooterConfig] = useState<FooterModel[]>();
  useInitFooter((datas) => {
    setFooterConfig(datas);
  }, props?.unionConfig);

  const getShowIcon = (item: FooterModel): string => {
    const pathName = window.location.pathname;
    const tabUrl = item?.tabUrl || "";
    if (tabUrl?.indexOf(pathName) > -1) {
      return item.tabIconSelected || "";
    } else {
      return item.tabIconDefualt || "";
    }
  };

  return (
    <div className="footer-part">
      {footerConfig?.map((item: FooterModel) => {
        return (
          <div>
            {item?.tabIconShow && (
              <div>
                <DFImage src={getShowIcon(item)} />
              </div>
            )}
            {item?.tabTextShow && item.tabText && (
              <div style={{ color: item.tabTextColor }}>{item.tabText}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default memo(FooterPart);
